// extracted by mini-css-extract-plugin
export default {"TextChangingTitle":"TextChangingTitle_TextChangingTitle__YFAdx","show":"TextChangingTitle_show__Q72pV","showSubtitle":"TextChangingTitle_showSubtitle__7BKZf"};